import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ModoExibicaoPersistidoService {
  private primeiraNavegacaoEmAndamento = true;
  private iniciado = false;
  private readonly paginaRecarregada = typeof performance !== 'undefined' && performance.getEntriesByType('navigation')
    .some(entry => (entry as PerformanceNavigationTiming).type === 'reload');

  public constructor(private router: Router) {}

  public iniciar(): void {
    if (this.iniciado)
      return;

    this.iniciado = true;
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      take(1)
    ).subscribe(() => setTimeout(() => this.primeiraNavegacaoEmAndamento = false));
  }

  public deveRestaurarModoExibicao(): boolean {
    return this.primeiraNavegacaoEmAndamento && this.paginaRecarregada;
  }
}
